<template>
    <div>
        <!-- <div class="all_div">
            <select>
                <option>全部</option>
            </select>
        </div> -->
        <!--  -->
        <div class="list_div">
            <div class="meal_item" v-for="(item,index) in list" :key="index">
                <div class="meal_left">
                    <div class="title">{{item.rechargeName}}</div>
                    <div class="time">{{item.updatetime}}</div>
                </div>
                <div class="meal_right">
                    <div class="status">{{item.status==0?'待支付':item.status==1?'已支付':'已取消'}}</div>
                    <div class="value">￥{{item.totalfee}}</div>
                </div>
            </div>
        </div>
        <div class="notText" v-if="notText">{{text}}</div>
    </div>
</template>

<script>
import autho from '../autho/autho.js';

var that;
export default {
    data(){
        return {
            text:'您暂无记录哦!',
            record:true,
            action_name:'day',
            list:[],
            accountCode:null,
            hasNextPage:false,
            page:1,
            notText:false
        }
    },
    beforeCreate(){
        document.querySelector('body').style.background = '#f6f6f6'
    },
    activated(){
        that = this;
        that.accountCode = that.$route.query.accountCode;
        that.page = 1;
        that.list = [];
        that.notText = false;
        that.requestFun(that.accountCode,that.page)
        window.addEventListener('scroll', that.handleScroll)
    },
    deactivated(){
        window.removeEventListener('scroll', that.handleScroll)
    },
    methods:{
        //请求数据
        async requestFun(accountCode,page){
            const res = await autho.request('token','post','/gzhWxApiController/getBillList',{
                    accountCode:accountCode,
                    page:page,
                    status:''
                })
            autho.resetDataFun(res,function(){
                let _data = res.data.data;
                that.hasNextPage = _data.hasNextPage;
                if(_data.list.length > 0){
                    that.list = that.list.concat(_data.list);
                }else{
                    that.notText = true
                }
            })
        },
        //加载更多
        handleScroll(){
            var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
            if(scrollTop + windowHeight > scrollHeight - 240){
                if(that.hasNextPage == true){
                    that.hasNextPage = false;
                    that.page++;
                    that.requestFun(that.accountCode,that.page)
                }
            }
        }
    }
}
</script>

<style scoped>
.all_div {
    height: 0.4rem;
    padding: 0 0.1rem;
    background: #fff;
    display: flex;
    align-items: center;
}
.all_div select {
    border: none;
    outline: none;
    font-size: 0.12rem;
    color: #3e5f8a;
}
.list_div {
    background: #fff;
    margin-top: 0.1rem;
}
.meal_item {
    border-bottom: 1px solid #f3f3f3;
    height: 0.8rem;
    padding: 0 0.1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.title {
    font-size: 0.18rem;
    color: #3e5f8a;
}
.time {
    font-size: 0.14rem;
    color: #ccc;
    margin-top: 0.1rem;
}
.meal_right {
    text-align: right;
}
.status {
    font-size: 0.14rem;
    color: #333;
}
.value {
    font-size: 0.16rem;
    color: #ccc;
    margin-top: 0.1rem;
}
.notText {
    margin-top: 1rem;
    font-size: 0.16rem;
    text-align: center;
}
</style>
